import { z } from 'zod';

import { Power } from '../fields/Power';

import { Efficiency } from '../fields/Efficiency';

export const performance = z
    .object({
        standbyPower: Power.validators.value,
        efficiency: Efficiency.validator.default({}),
        losses: Power.validators.nomMax,
    })
    .default({});
